import { isEmpty } from 'lodash';
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import MainCard from 'components/MainCard';
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { filterOptionLabel } from 'pages/globals/global';
import SectionCard from 'components/section/SectionCard';
import { useLocation, useNavigate } from 'react-router-dom';
import AntdValuePreview from 'components/dev/AntdValuePreview';
import CustomTextInput from 'components/inputs/CustomTextInput';
import CustomDateInput from 'components/inputs/CustomDateInput';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import DetailPageHeader from 'components/header/DetailPageHeader';
import FormSubmitButton from 'components/button/FormSubmitButton';
import { Col, Form, Input, Row, Select, Spin, TimePicker } from 'antd';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { useGetSingleIdentityMutation } from 'store/features/process/processApi';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

function Create() {
	const [form] = Form.useForm();

	const { state } = useLocation();
	const navigate = useNavigate();

	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState();

	const [GetSingleIdentity, { error: errorData, isSuccess: isSingleCaseSuccess, isLoading: isSingleCaseLoading, isError: isSingleCaseError }] =
		useGetSingleIdentityMutation();

	const onSubmitHandler = (payload) => {
		setSubmitData(payload);
		setShowModal(true);
	};

	const onModalOkHandler = () => {
		GetSingleIdentity({
			operation: 'add-single',
			processCode: state?.processCode,
			suffixCode: '',
			data: submitData,
		});
	};

	useEffect(() => {
		if (isSingleCaseSuccess) {
			toast.success('Success! Action completed ', toastConfig);
			navigate(-1);
		}

		if (isSingleCaseError) {
			if (errorData?.data?.code === '501') {
				toast.error(errorData?.data?.message, toastConfig);
			} else {
				toast.error('Failed! Action not completed', toastConfig);
			}
		}
	}, [isSingleCaseSuccess, isSingleCaseError, errorData]);

	useEffect(() => {
		if (isEmpty(state?.processCode)) {
			navigate(-1);
		}
	}, [state?.processCode]);

	return (
		<Box>
			<DetailPageHeader
				title={'Create ' + (state?.processName ?? '')}
				image={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />}
			/>

			<Spin spinning={isSingleCaseLoading} style={{ maxHeight: '100%' }}>
				<SectionCard>
					<Form
						form={form}
						id="attendance-shift-create"
						layout="vertical"
						initialValues={{
							shift: [null],
						}}
						requiredMark={false}
						onFinish={onSubmitHandler}
						autoComplete="off"
					>
						<AntdValuePreview form={form} show={false} />

						<Form.Item noStyle name="formattedDate" />
						<Row gutter={[16, 0]}>
							<Col xs={24}>
								<CustomTextInput
									form={form}
									name="policyName"
									label="Shift Name"
									placeholder="Write here"
									rules={[
										{
											required: true,
											message: 'Shift Name Field is required',
										},
									]}
								/>
							</Col>

							<Col xs={24}>
								<CustomDateInput
									form={form}
									name="date"
									label="Effective Date"
									onChange={(date, dateString) => {
										form.setFieldValue('formattedDate', dateString);
									}}
									rules={[
										{
											required: true,
											message: 'Effective date field is required',
										},
									]}
								/>
							</Col>

							<Col xs={24}>
								<Form.List name="shift">
									{(fields) => (
										<Box>
											<TableContainer
												sx={{
													mb: 3,
													'& table, & th, & td': {
														border: '1px solid #e0e0e0',
														borderCollapse: 'collapse',
													},
													'& th': {
														py: '5px',
														px: '11px',
													},
													'& td': {
														p: '5px',
													},
													'& td .ant-form-item': {
														marginBottom: '0px',
													},
													'& .condition-msg': {
														py: 3,
													},
												}}
											>
												<Table>
													<TableHead>
														<TableRow sx={{ backgroundColor: '#e5e5e5' }}>
															<TableCell sx={{ minWidth: '15rem' }}>Earliest Entry Time Counts</TableCell>
															<TableCell sx={{ minWidth: '10rem' }}>Latest Entry Timeline</TableCell>
															<TableCell sx={{ minWidth: '10rem' }}>Earliest Exit Timeline</TableCell>
															<TableCell sx={{ minWidth: '10rem' }}>Latest Exit Time Count for OT</TableCell>
															<TableCell sx={{ minWidth: '10rem' }}>Start of Core Hours</TableCell>
															<TableCell sx={{ minWidth: '10rem' }}>End of Core Hours</TableCell>
															<TableCell sx={{ minWidth: '10rem' }}>Total Working Hours</TableCell>
															<TableCell sx={{ minWidth: '10rem' }}>Overtime Allowance</TableCell>
														</TableRow>
													</TableHead>
													<TableBody>
														{fields?.map((field, index) => (
															<TableRow key={index}>
																<TableCell sx={{ verticalAlign: 'sub', width: '10rem' }}>
																	<Form.Item
																		style={{ margin: 0 }}
																		name={[field.name, 'earliestEntry']}
																		rules={[
																			{
																				required: true,
																				message: 'Field is required',
																			},
																		]}
																	>
																		<TimePicker use12Hours format="h:mm a" style={{ width: '100%' }} />
																	</Form.Item>
																</TableCell>

																<TableCell sx={{ verticalAlign: 'sub', width: '10rem' }}>
																	<Form.Item
																		style={{ margin: 0 }}
																		name={[field.name, 'latestEntry']}
																		rules={[
																			{
																				required: true,
																				message: 'Field is required',
																			},
																		]}
																	>
																		<TimePicker use12Hours format="h:mm a" style={{ width: '100%' }} />
																	</Form.Item>
																</TableCell>

																<TableCell sx={{ verticalAlign: 'sub', minWidth: '10rem' }}>
																	<Form.Item
																		style={{ margin: 0 }}
																		name={[field.name, 'earliestExit']}
																		rules={[
																			{
																				required: true,
																				message: 'Field is required',
																			},
																		]}
																	>
																		<TimePicker use12Hours format="h:mm a" style={{ width: '100%' }} />
																	</Form.Item>
																</TableCell>

																<TableCell sx={{ verticalAlign: 'sub', minWidth: '10rem' }}>
																	<Form.Item
																		style={{ margin: 0 }}
																		name={[field.name, 'latestExit']}
																		rules={[
																			{
																				required: true,
																				message: 'Field is required',
																			},
																		]}
																	>
																		<TimePicker use12Hours format="h:mm a" style={{ width: '100%' }} />
																	</Form.Item>
																</TableCell>

																<TableCell sx={{ verticalAlign: 'sub', minWidth: '10rem' }}>
																	<Form.Item
																		style={{ margin: 0 }}
																		name={[field.name, 'startCore']}
																		rules={[
																			{
																				required: true,
																				message: 'Field is required',
																			},
																		]}
																	>
																		<TimePicker use12Hours format="h:mm a" style={{ width: '100%' }} />
																	</Form.Item>
																</TableCell>

																<TableCell sx={{ verticalAlign: 'sub', minWidth: '10rem' }}>
																	<Form.Item
																		style={{ margin: 0 }}
																		name={[field.name, 'endCore']}
																		rules={[
																			{
																				required: true,
																				message: 'Field is required',
																			},
																		]}
																	>
																		<TimePicker use12Hours format="h:mm a" style={{ width: '100%' }} />
																	</Form.Item>
																</TableCell>

																<TableCell sx={{ verticalAlign: 'sub', minWidth: '10rem' }}>
																	<Form.Item
																		style={{ margin: 0 }}
																		name={[field.name, 'workingHours']}
																		rules={[
																			{
																				required: true,
																				message: 'Field is required',
																			},
																		]}
																	>
																		<Input placeholder="Write here" autoComplete="off" />
																	</Form.Item>
																</TableCell>

																<TableCell sx={{ verticalAlign: 'sub', minWidth: '10rem' }}>
																	<Form.Item
																		style={{ margin: 0 }}
																		name={[field.name, 'overtimeAllowance']}
																		rules={[
																			{
																				required: true,
																				message: 'Field is required',
																			},
																		]}
																	>
																		<Select
																			allowClear
																			showSearch
																			filterOption={filterOptionLabel}
																			placeholder="Select from the list"
																			autoComplete="off"
																		>
																			<Select.Option value="allowed">Allowed</Select.Option>
																			<Select.Option value="notAllowed">Not Allowed</Select.Option>
																		</Select>
																	</Form.Item>
																</TableCell>
															</TableRow>
														))}
													</TableBody>
												</Table>
											</TableContainer>
										</Box>
									)}
								</Form.List>
							</Col>

							<Col xs={24}>
								<FormSubmitButton />
							</Col>
						</Row>
					</Form>
				</SectionCard>
			</Spin>

			{showModal && (
				<ComptrollerConfirmModal
					showModal={showModal}
					setShowModal={setShowModal}
					handleSubmit={onModalOkHandler}
					modalData={{
						head: state?.processName ?? '',
						label: 'Do you want to proceed?',
					}}
				/>
			)}
		</Box>
	);
}

export default Create;
